module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_9016.cb8c1d04.png";